import ServiceApi from "../ServiceApi";
class ReturnGiftServiceApi extends ServiceApi {
  constructor() {
    super("returnGiftService", "returnGift");
  }
  /**
   *
   * @param {string} activityKey
   * @param {string} locale
   */
  getRewards(activityKey, locale) {
    const params = {
      activityKey: activityKey,
      locale: locale,
    };

    return this.request("getRewards", params);
  }
}
const service = new ReturnGiftServiceApi();
export default service;
